import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function SkeletonImage({
  width = "100%",
  height = "100%",
  ...props
}) {
  return /* @__PURE__ */ jsx(Image, {
    $width: width,
    $height: height,
    "data-testid": "ds-skeleton-image",
    ...props
  });
}
const Image = styled.div.withConfig({
  displayName: "Image",
  componentId: "sc-7fb4p2-0"
})(["width:", ";min-width:10px;height:", ";min-height:10px;border-radius:", ";background:", ";"], (props) => props.$width, (props) => props.$height, token.radiusBase, token.gray100a);
export {
  Image,
  SkeletonImage
};
//# sourceMappingURL=SkeletonImage.js.map
